var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "mobile-navigation",
      class: { open: _vm.isMobileNavigationOpen },
      attrs: {
        "aria-labelledby": "mobile-navigation-toggler",
        itemscope: "",
        itemtype: "https://schema.org/SiteNavigationElement",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNavigationInitialized,
              expression: "isNavigationInitialized",
            },
          ],
        },
        [
          _c(
            "ul",
            { staticClass: "breadcrumb d-block px-3 py-0" },
            [
              _c("li", {
                staticClass: "btn-close",
                attrs: {
                  "aria-label": _vm.$translate("Ceres::Template.closeIcon"),
                },
                on: {
                  click: function ($event) {
                    return _vm.closeNavigation()
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "breadcrumb-item breadcrumb-item-home",
                  on: {
                    click: function ($event) {
                      return _vm.slideTo(null, true)
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "dia-shop-nav__logo",
                    attrs: {
                      alt: "Zwergenträume",
                      src: "https://cdn02.plentymarkets.com/oueuwrwk0stw/frontend/Zwergentraeume_Logo_RGB_2023.png",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.breadcrumbs, function (breadcrumb) {
                return _c(
                  "li",
                  {
                    staticClass: "breadcrumb-item",
                    on: {
                      click: function ($event) {
                        return _vm.slideTo(breadcrumb.parent, true)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(breadcrumb.name) +
                        "\n            "
                    ),
                  ]
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu w-100 p-0 m-0 menu-active",
              attrs: { id: "menu-1" },
            },
            [
              _vm.dataContainer1.parent
                ? _c(
                    "li",
                    {
                      staticClass: "ddown btn-back",
                      on: {
                        click: function ($event) {
                          _vm.slideTo(
                            (_vm.dataContainer1.parent &&
                              _vm.dataContainer1.parent.parent) ||
                              null,
                            true
                          )
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "nav-direction btn-up" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "10",
                              height: "18",
                              viewBox: "0 0 10 18",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                fill: "#43484D",
                                "fill-rule": "evenodd",
                                stroke: "#6C757D",
                                d: "M1.774 1.133a.451.451 0 0 0-.64 0 .451.451 0 0 0 0 .64L8.36 9l-7.228 7.225a.456.456 0 1 0 .319.775.442.442 0 0 0 .319-.134l7.55-7.548a.45.45 0 0 0 .002-.637l-7.55-7.548z",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dataContainer1.categories, function (category) {
                return _c("li", { staticClass: "ddown" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.getCategoryUrl(category.url),
                        itemprop: "name",
                      },
                    },
                    [_vm._v(_vm._s(category.details[0].name))]
                  ),
                  _vm._v(" "),
                  category.childCount
                    ? _c(
                        "span",
                        {
                          staticClass: "nav-direction",
                          on: {
                            click: function ($event) {
                              return _vm.slideTo(category)
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "10",
                                height: "18",
                                viewBox: "0 0 10 18",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  fill: "#43484D",
                                  "fill-rule": "evenodd",
                                  stroke: "#6C757D",
                                  d: "M1.774 1.133a.451.451 0 0 0-.64 0 .451.451 0 0 0 0 .64L8.36 9l-7.228 7.225a.456.456 0 1 0 .319.775.442.442 0 0 0 .319-.134l7.55-7.548a.45.45 0 0 0 .002-.637l-7.55-7.548z",
                                },
                              }),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              }),
              _vm._v(" "),
              _vm.dataContainer1.categories[0]
                ? _vm._l(
                    _vm.dataContainer1.categories[0].siblingCount -
                      _vm.dataContainer1.categories.length,
                    function (number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder m-3",
                          style: {
                            width: Math.random() * 20 + 60 + "%",
                          },
                        }),
                      ])
                    }
                  )
                : _vm.dataContainer1.parent
                ? _vm._l(
                    _vm.dataContainer1.parent.childCount,
                    function (number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder m-3",
                          style: {
                            width: Math.random() * 20 + 60 + "%",
                          },
                        }),
                      ])
                    }
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu w-100 p-0 m-0",
              attrs: { id: "menu-2" },
            },
            [
              _vm.dataContainer2.parent
                ? _c(
                    "li",
                    {
                      staticClass: "ddown btn-back",
                      on: {
                        click: function ($event) {
                          _vm.slideTo(
                            (_vm.dataContainer2.parent &&
                              _vm.dataContainer2.parent.parent) ||
                              null,
                            true
                          )
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "nav-direction btn-up" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "10",
                              height: "18",
                              viewBox: "0 0 10 18",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                fill: "#43484D",
                                "fill-rule": "evenodd",
                                stroke: "#6C757D",
                                d: "M1.774 1.133a.451.451 0 0 0-.64 0 .451.451 0 0 0 0 .64L8.36 9l-7.228 7.225a.456.456 0 1 0 .319.775.442.442 0 0 0 .319-.134l7.55-7.548a.45.45 0 0 0 .002-.637l-7.55-7.548z",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dataContainer2.categories, function (category) {
                return _c("li", { staticClass: "ddown" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.getCategoryUrl(category.url),
                        itemprop: "name",
                      },
                    },
                    [_vm._v(_vm._s(category.details[0].name))]
                  ),
                  _vm._v(" "),
                  category.childCount
                    ? _c(
                        "span",
                        {
                          staticClass: "nav-direction",
                          on: {
                            click: function ($event) {
                              return _vm.slideTo(category)
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "10",
                                height: "18",
                                viewBox: "0 0 10 18",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  fill: "#43484D",
                                  "fill-rule": "evenodd",
                                  stroke: "#6C757D",
                                  d: "M1.774 1.133a.451.451 0 0 0-.64 0 .451.451 0 0 0 0 .64L8.36 9l-7.228 7.225a.456.456 0 1 0 .319.775.442.442 0 0 0 .319-.134l7.55-7.548a.45.45 0 0 0 .002-.637l-7.55-7.548z",
                                },
                              }),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              }),
              _vm._v(" "),
              _vm.dataContainer2.categories[0]
                ? _vm._l(
                    _vm.dataContainer2.categories[0].siblingCount -
                      _vm.dataContainer2.categories.length,
                    function (number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder m-3",
                          style: {
                            width: Math.random() * 20 + 60 + "%",
                          },
                        }),
                      ])
                    }
                  )
                : _vm.dataContainer2.parent
                ? _vm._l(
                    _vm.dataContainer2.parent.childCount,
                    function (number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder m-3",
                          style: {
                            width: Math.random() * 20 + 60 + "%",
                          },
                        }),
                      ])
                    }
                  )
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      !_vm.isNavigationInitialized
        ? [
            _c("ul", { staticClass: "breadcrumb" }, [
              _c("li", {
                staticClass: "btn-close",
                attrs: {
                  "aria-label": _vm.$translate("Ceres::Template.closeIcon"),
                },
                on: {
                  click: function ($event) {
                    return _vm.closeNavigation()
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(0),
            ]),
            _vm._v(" "),
            _c("loading-animation"),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "breadcrumb-item" }, [
      _c("i", { staticClass: "fa fa-home", attrs: { "aria-hidden": "true" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }